import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageToggle: React.FC = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'ar' ? 'fr' : 'ar';
        i18n.changeLanguage(newLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className="px-3 py-1 text-sm font-medium text-primary bg-white rounded-full hover:bg-gray-100 transition-colors border border-primary"
            aria-label="Toggle Language"
        >
            {i18n.language === 'ar' ? 'Français' : 'العربية'}
        </button>
    );
};

export default LanguageToggle;
